import { useState } from "react";
import Modal from '../components/Modal';
import { Link } from "react-router-dom";

import features from '../img/AwM-home-img.png'
import expert from '../video/Expert-support.gif'
import fast from '../video/Fast-setup.gif'
import customise from '../video/Customise.gif'
import value from '../video/Value.gif'
import video from '../video/AwardMost_video.mp4'
import neil from '../img/Neil.png'
import gary from '../img/Gary.png'
import UKCXA from '../img/UKCXA.png' 
import UKEXA from '../img/UKEXA.png' 
import GSA from '../img/GSA.png' 
import GCXA from '../img/GCXA.png' 


function Button() {
    const [isOpen, setIsOpen] = useState(false);

      return  (
        <>
          <button onClick={() => setIsOpen(true)}>  
              Book free consultations       
          </button>
        {isOpen && <Modal setIsOpen={setIsOpen} />}
        </>
      );
}

function NewHomepage() {
    return (
        <>
            <div className='content new-homepage slide-down'>
                <div className="main-wrapper text-center first-box section-padd">
                    <h1>Powering Efficient & Professional <br/> Business Awards</h1>
                    <p>AwardMost is the all-in-one platform built for awards organisers. <br/> From managing submissions and judging to delivering stunning events - we simplify every step of the awards journey.</p>

                    <Button />
                    <br/><br/>
                    <Link to='/solutions'>
                        See How It Works
                    </Link>

                    <video style={{marginTop: '50px'}} src={video} width="100%" controls></video>
                </div>

                <div className="second-box section-padd">
                    <div className="main-wrapper">
                        <div className="text-center">
                            <h2>Why AwardMost</h2>
                            <p className="sub-heading">Built by award experts, for award professionals.</p>
                            <p>With over 15 years of experience organising global business awards, we know what it takes to deliver success. AwardMost helps you:</p>
                        </div>
                        <div className="why-app">
                            <div>
                                <p className="sub-heading">Cut</p>
                                <p>admin time in half</p>
                            </div>
                            <div>
                                <p className="sub-heading">Get</p>
                                <p>more high-quality submissions</p>
                            </div>
                            <div>
                                <p className="sub-heading">Make</p>
                                <p>judging faster, fairer, and fully transparent</p>
                            </div>
                            <div>
                                <p className="sub-heading">Deliver</p>
                                <p>outstanding experiences for entrants, judges, and sponsors</p>
                            </div>
                        </div>
                    </div> 
                </div>

                <div className="third-box section-padd">
                    <div className="main-wrapper">
                    <h2>Solutions</h2>
                        <div className="new-solutions">
                            <div className="left">
                                <p className="sub-heading">Built for Every Stage of Your Awards</p>
                                <p>Whether you're running your ﬁrst awards or scaling to multiple categories and judging rounds, AwardMost adapts to ﬁt your process - and makes it better.</p>
                                <Link to='/solutions'>
                                    <button>Explore awards solutions</button>
                                </Link>
                            </div>
                            <div className="right">
                                <div>
                                <p className="solutions-h" style={{marginTop: '0px'}}>Your awards process is all over the place?</p>
                                <p className="solutions-p">AwardMost brings everything into one platform - submissions, scoring, communications, reporting - so you stay in control from start to ﬁnish. <br/> No more spreadsheets, last-minute chaos, or lost emails.</p>

                                <ul>
                                    <li>Centralised entry portal</li>
                                    <li>Judge management in one click</li>
                                    <li>Real-time dashboards and reports</li>
                                </ul>

                                </div>


                                <div>
                                <p className="solutions-h">Too much manual admin - drowning in emails?</p>
                                <p className="solutions-p">Automate the busywork. From applicant conﬁrmations to judge allocations and reminders, AwardMost takes care of the repetitive tasks so you can focus on delivering an outstanding event</p>

                                <ul>
                                    <li>Automated emails & deadlines</li>
                                    <li>Smart judge reminders</li>
                                    <li>Entry tracking with zero chasing</li>
                                </ul>
                                </div>

                                <div>
                                <p className="solutions-h">Need a secure and fair judging process?</p>
                                <p className="solutions-p">AwardMost ensures judging is structured, transparent, and fully auditable. Judges can only access entries after signing your NDA, and every score is tracked and time-stamped</p>

                                <ul>
                                    <li>NDA gating before scoring</li>
                                    <li>Multi-round and group judging</li>
                                    <li>Secure, unbiased scoring ﬂow</li>
                                </ul>
                                </div>

                                <div>
                                <p className="solutions-h">Want to grow but your current system can't keep up?</p>
                                <p className="solutions-p">Whether you're adding new categories, expanding internationally, or going hybrid, AwardMost scales with you. Flexible features mean your awards evolve - without starting from scratch.</p>
                                
                                <ul>
                                    <li>Customisable categories & scoring</li>
                                    <li>Multiple awards programs</li>
                                    <li>Tools for live, virtual, and hybrid events</li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fourth-box section-padd">
                    <div className="main-wrapper">
                        <div className="new-features">
                            <div className="left">
                             <h2>Features</h2>
                                <div>
                                    <p className="sub-heading">Entry Management</p>
                                    <p className="solutions-p">Easily collect and manage entries with a branded, user-friendly portal.</p>
                                </div>

                                <div>
                                    <p className="sub-heading">Judge Allocation & Scoring</p>
                                    <p className="solutions-p">Assign judges in one click, track scores in real-time, and ensure a fair, audited process.</p>
                                </div>

                                <div>
                                    <p className="sub-heading">Live & Online Event Tools</p>
                                    <p className="solutions-p">Run smooth hybrid or in-person ceremonies with everything in one place - agenda, badges, table plans, and more.</p>
                                </div>

                                <div>
                                    <p className="sub-heading">Reporting & Feedback</p>
                                    <p className="solutions-p">Give entrants meaningful feedback. Track engagement. Make smarter decisions for future events.</p>
                                </div>

                                <div>
                                    <p className="sub-heading">Branded Experience</p>
                                    <p className="solutions-p">Customisable to match your brand - so your awards look as premium as they are.</p>
                                </div>
                            </div>
                            <div className="right">
                                <img src={features} alt="img" />
                            </div>
                        </div>
                        <p style={{textAlign: 'center', width: '100%'}}>
                        <Link to='/features'>
                            <button>Explore all features</button>
                        </Link>
                        </p>
                    </div>
                </div>

                <div className="fifth-box section-padd">
                    <div className="main-wrapper">
                        <h2>Why Organisers Choose Us <br/> Over the Competition</h2>
                        <div className="organisers">
                            <div>
                                <img src={expert} alt="gif" width={300}/>
                                <p>Expert support throughout the awards lifecycle</p>
                            </div>

                            <div>
                                <img src={fast} alt="gif" width={300}/>
                                <p>Fast setup and onboarding</p>
                            </div>

                            <div>
                                <img src={customise} alt="gif" width={300}/>
                                <p>Customised to your format, categories, and judging process</p>
                            </div>

                            <div>
                                <img src={value} alt="gif" width={300}/>
                                <p>Better value, without compromise</p>
                            </div>
                        </div>
                        <p style={{width: '100%', textAlign: 'center'}}>
                            <Button />
                        </p>
                    </div>
                </div>

                <div className="sixth-box section-padd">
                    <div className="main-wrapper">
                        <div className="new-testimonials">
                            <div>
                                <p><span className="sub-heading">"We trust AwardMost</span> <br/> for our awards management needs because they prioritise the security of our customer data. With their strict data protection protocols, we have peace of mind knowing our information is safe and conﬁdential. Highly recommended!"</p>

                                <div className="new-bio">
                                    <img src={neil} alt="gif" width={100}/>
                                    <p><b>Neil Skehel</b> <br/> CEO, Awards International</p>
                                </div>
                            </div>

                            <div>
                                <p><span className="sub-heading">"AwardMost is incredibly user-friendly,</span> <br/> easily accessible and allows me to review and score entries with ease. As a Head Judge, with a busy day job, it has transformed my awards experience."</p>
                                
                                <div className="new-bio">
                                    <img src={gary} alt="gif" width={100} height={100}/>
                                    <p><b>Gary Jackson</b> <br/> Group Director of Communications & <br/> Customer Success for Mears Group</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="seventh-box section-padd">
                    <div className="main-wrapper">
                        <h2>Results That Matter</h2>
                        <div className="new-results">
                            <div>
                                <p><span className="sub-heading">10,000+</span> <br/> entries processed</p>

                                <div className="awards">
                                    <img src={UKCXA} alt="gif" width={300}/>
                                </div>
                            </div>

                            <div>
                                <p><span className="sub-heading">500+</span> <br/> judges supported</p>

                                <div className="awards">
                                    <img src={UKEXA} alt="gif" width={300}/>
                                </div>
                            </div>

                            <div>
                                <p><span className="sub-heading">98%</span> <br/> organiser satisfaction</p>

                                <div className="awards">
                                    <img src={GSA} alt="gif" width={300}/>
                                </div>
                            </div>

                            <div>
                                <p><span className="sub-heading">Trusted</span> <br/> by top business awards <br/> all over the world</p>

                                <div className="awards">
                                    <img src={GCXA} alt="gif" width={300}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="eight-box section-padd">
                    <div className="main-wrapper">
                        <div className="elevate">
                            <h2>Ready to Elevate Your Awards?</h2>
                            <p>Say goodbye to spreadsheets, email chaos, and clunky software. <br/> Say hello to AwardMost.</p>
                            <Button />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewHomepage;




